<template lang="pug">
.table-statement
  .table-responsive
    table.table.table-new
      thead
        tr
          th {{ $t("ui.date") }}
          th {{ $t("ui.request_type") }}
          th {{ $t("ui.amount") }}
          th {{ $t("ui.attachment_info") }}
          th {{ $t("ui.status") }}
          th {{ $t("ui.remark") }}
          th {{ $t("ui.eta") }}
      template(v-if="!loading")
        tbody(v-if="transactionList && transactionList.length > 0")
          tr(v-for="item in transactionList")
            td {{ $moment(item.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            td {{ item.request_type }}
            td {{ $numeral(item.amount).format("0,0.00") }}
            td
              template(v-if="item.request_type == 'DEPOSIT'") 
                a(:href="item.attachment_path" onclick="window.open(this.href,'result','top=10,height=600,width=400,status=no,toolbar=no,menubar=no,location=no');return false;")
                  i.fas.fa-file(style="margin-left: 5px;")
              template(v-else)
                span -
            td
              span.text-uppercase(:class="$helpers.getStatusClass(item.status)") {{ $t("ui." + $helpers.getStatusText(item.status)) }}
            td {{ item.remark }}
            td {{ $moment(item.created_date).add(5, "m").format("YYYY-MM-DD HH:mm:ss") }}
        tbody(v-else)
          tr
            td(colspan=7) {{ $t('ui.no_record') }}
      template(v-else)
        tbody
          tr
            td(colspan=7) 
              i.fas.fa-sync.fa-spin
  </template>
  
  <script>
  export default {
    components: {},
    data() {
      return {
        loading: false,
        feedback: {
          success: true,
          status: ""
        },
        transactionList: []
      }
    },
    validations: { },
    computed: {
      isLoggedIn(){
        return this.$store.getters.isLoggedIn
      },
      accountID() {
        return this.$store.getters.accountID
      },
      sessionToken() {
        return this.$store.getters.sessionToken
      }
    },
    mounted(){
      this.memberTicketList()
    },
    methods:{
      memberTicketList() {
        if (this.isLoggedIn) {
          this.loading = true
          let login_id = this.accountID
          let auth_token = this.sessionToken
          this.$store
            .dispatch("user/memberTicketList", { login_id, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.transactionList = response.data
              } else {
                this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
            })
        }
      }
    }
  }
  </script>